import { createBrowserRouter } from 'react-router';

import { AuthLayout, AuthLinkLayout, DashboardLayout, MarketingLayout, RootLayout } from './components/layouts';
import { LandingPage } from './pages/Landing';
import { PricingPage } from './pages/Pricing';
import { DocsPage } from './pages/Docs';
import { IntegrationN8nPage } from './pages/IntegrationN8n';
import { BlogPage } from './pages/Blog';
import { BlogPostPage } from './pages/BlogPost';
import { PrivacyPage } from './pages/Privacy';
import { TermsPage } from './pages/Terms';
import { LoginPage } from './pages/Login';
import { RegisterPage } from './pages/Register';
import { VerifyEmailPage } from './pages/VerifyEmail';
import { CancelSignupPage } from './pages/CancelSignup';
import { OverviewPage } from './pages/Overview';
import { KeysPage } from './pages/Keys';
import { UsagePage } from './pages/Usage';
import { PlaygroundPage } from './pages/Playground';
import { BillingPage } from './pages/Billing';
import { AdminPage } from './pages/Admin';
import { NotFoundPage } from './pages/NotFound';

export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    children: [
      {
        element: <MarketingLayout />,
        children: [
          { index: true, element: <LandingPage /> },
          { path: 'pricing', element: <PricingPage /> },
          { path: 'docs', element: <DocsPage /> },
          { path: 'integrations/n8n', element: <IntegrationN8nPage /> },
          { path: 'blog', element: <BlogPage /> },
          { path: 'blog/:slug', element: <BlogPostPage /> },
          { path: 'privacy', element: <PrivacyPage /> },
          { path: 'terms', element: <TermsPage /> },
          { path: '*', element: <NotFoundPage /> },
        ],
      },
      {
        element: <AuthLayout />,
        children: [
          { path: 'login', element: <LoginPage /> },
          { path: 'register', element: <RegisterPage /> },
        ],
      },
      {
        element: <AuthLinkLayout />,
        children: [
          { path: 'verify-email', element: <VerifyEmailPage /> },
          { path: 'cancel-signup', element: <CancelSignupPage /> },
        ],
      },
      {
        path: 'app',
        element: <DashboardLayout />,
        children: [
          { index: true, element: <OverviewPage /> },
          { path: 'keys', element: <KeysPage /> },
          { path: 'usage', element: <UsagePage /> },
          { path: 'playground', element: <PlaygroundPage /> },
          { path: 'billing', element: <BillingPage /> },
          { path: 'admin', element: <AdminPage /> },
        ],
      },
    ],
  },
]);
